import { API_BASE_URL } from "./BaseUrl"
import { postApiWithoutToken, getApiWithToken, putApiWithToken, deleteApi, postApiWithToken, imgUploadApi, getApiWithoutToken } from "./ApiInterfaces"
import axios from "axios";


// Adimin Login 
export const loginAdmin = async (values) => {
    const res = await postApiWithoutToken("/admin/login", values)
    return res;
}

export const getAdminDetailsApi = async () => {
    const res = await getApiWithToken("/admin/getAdminDetails")
    return res;
}


// Admin Get Dashboard Data

export const adminGetDashboardData = async () => {
    const res = await getApiWithToken(`/admin/getAllDashboardData?from=&to=`)
    return res;
}

export const adminGenerateReport = async (type, from, to) => {
    const res = await getApiWithToken(`/admin/generateReports?startDate=${from}&endDate=${to}&reportType=${type}`)
    return res;
}


export const adminProfileUpdate = async (values) => {
    const res = await putApiWithToken("/admin/updateAdminProfile", values)
    return res;
}

export const forgetPassword = async (values) => {
    const res = await postApiWithoutToken("/admin/forgetPassword", values)
    return res;
}

export const resetPassword = async (values) => {

    return axios.put(API_BASE_URL + "/admin/resetPassword", { password: values?.password }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${values?.token}`,
        },
    });

}

export const getAllUsers = async (limit, page, search = "") => {
    const res = await getApiWithToken(`/admin/getAllUser?page=${page}&limit=${limit}&search=${search}`);
    return res;
}

// Admin Get All Users
export const adminGetAllUserList = async (limit = "", page = "", search = "", role = "", country="", city="") => {
    const res = await getApiWithToken(`/admin/getPartnersList?role=${role}&search=${search}&page=${page}&limit=${limit}&country=${country}&city=${city}`)
    return res;
}
export const adminUserChagneStatusApi = async (data) => {
    const res = await putApiWithToken(`/admin/approveOrRejectuser`, data)
    return res;
}
export const adminGetAllDeletedUserList = async (limit, page, search = "", role = "") => {
    const res = await getApiWithToken(`/admin/getAllDeletedUserList?role=${role}&search=${search}&page=${page}&limit=${limit}`)
    return res;
}
export const adminChangePartnerApprovalStatus = async (data) => {
    const res = await postApiWithToken(`/admin/changePartnerApprovalStatus`, data)
    return res;
}
export const adminChangeDriverDocumentsStatusApi = async (data) => {
    const res = await putApiWithToken(`/admin/approveOrRejectDriverDocuments`, data)
    return res;
}

export const approveOrRejectRentalVehicleStatusApi = async (data) => {
    const res = await putApiWithToken(`/admin/approveOrRejectRentalVehicleStatus`, data)
    return res;
}

export const approveOrRejectRestaurantDocApi = async (data) => {
    const res = await putApiWithToken(`/admin/approveOrRejectRestaurantDoc`, data)
    return res;
}

export const adminGetDriverDetailsById = async (id) => {
    const res = await getApiWithToken(`/admin/getDriverDetailsById?id=${id}`)
    return res;
}

export const rentalvendorDetailsById = async (id) => {
    const res = await getApiWithToken(`/admin/rentalvendorDetailsById?id=${id}`)
    return res;
}

export const editRentalVendorApi = async (data) => {
    const res = await putApiWithToken(`/admin/editRentalVendor`,data)
    return res;
}

export const editRestaurantApi = async (data) => {
    const res = await putApiWithToken(`/admin/editRestaurant`,data)
    return res;
}

export const restaurantById = async (id) => {
    const res = await getApiWithToken(`/admin/restaurantById?id=${id}`)
    return res;
}

export const getVehiclesListApi = () => {
    return getApiWithToken(`/admin/getVehiclesList`);
}
export const getVehiclesByIdApi = (id) => {
    return getApiWithToken(`/admin/getVehiclesList?vehicleId=${id}`);
}

export const addVehicleCategoryApi = (payload) => {
    return postApiWithToken(`/admin/addVehicleCategory`, payload)
}

export const getAllUsersListApi = (limit = "", page = "", search = "",country = "", city = "") => {
    return getApiWithToken(`/admin/getAllUsersList?search=${search}&page=${page}&limit=${limit}&country=${country}&city=${city}`)
}

export const getAdminConfigurationApi = () => {
    return getApiWithToken(`/admin/getAdminConfiguration`);
}

export const updateAdminConfigurationsApi = (payload) => {
    return putApiWithToken(`/admin/updateMinRideChargesByCityId`, payload)
}

export const getCategoryListApi = (bookingType="", countryId="", cityId="") => {
    return getApiWithToken(`/admin/getCategoryList?bookingType=${bookingType}&countryId=${countryId}&cityId=${cityId}`)
}

export const updateVehicleCategoryApi = (payload) => {
    return putApiWithToken(`/admin/updateVehicleCategory`, payload)
}

export const updateVehicleCategoryStatusApi = (payload) => {
    return putApiWithToken(`/admin/updateVehicleCategoryStatus`, payload)
}

export const getCategoryMakeAndModelApi = (bookingType = "") => {
    return getApiWithToken(`/admin/getCategoryMakeAndModel?bookingType=${bookingType}`)
}

export const addCategoryMakeAndModelApi = (payload) => {
    return postApiWithToken(`/admin/addCategoryMakeAndModel`, payload)
}
export const getAllMakesApi = () => {
    return getApiWithToken(`/admin/makes`);
}


export const updateMakeAndModelStatusApi = (payload) => {
    return putApiWithToken(`/admin/updateMakeAndModelStatus`, payload)
}

export const getRidesListApi = (limit = "", page = "", search = "", type="", userId="", country="", city="") => {
    return getApiWithToken(`/admin/getRidesList?search=${search}&page=${page}&limit=${limit}&type=${type}&userId=${userId}&country=${country}&city=${city}`)
}

export const getCustomerDetailsApi = (userId="") => {
    return getApiWithToken(`/admin/customerDetails?id=${userId}`)
}

export const foodOrdersListApi = (limit = "", page = "", search = "") => {
    return getApiWithToken(`/admin/foodOrdersList?search=${search}&page=${page}&limit=${limit}`)
}

export const getCuisinesListApi = (limit = "", page = "") => {
    return getApiWithToken(`/admin/cuisinesList?page=${page}&limit=${limit}`)
}

export const addOrUpdateCusineApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateCusine`, payload)
}

export const getMenuItemCategoryApi = (limit = "", page = "", countryId = "", cityId = "") => {
    return getApiWithToken(`/admin/getMenuItemCategory?page=${page}&limit=${limit}&countryId=${countryId}&cityId=${cityId}`)
}

export const addOrUpdateMenuItemCategoryApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateMenuItemCategory`, payload)
}

export const uploadFileApi = (payload) => {
    return imgUploadApi(`/admin/uploadFile`, payload)
}

export const updateCuisineStatusApi = (payload) => {
    return putApiWithToken(`/admin/updateCuisineStatus`, payload)
}

export const updateMenuItemCategoryStatusApi = (payload) => {
    return putApiWithToken(`/admin/updateMenuItemCategoryStatus`, payload)
}

export const addCityWithTax = (payload) => {
    return postApiWithToken('/admin/addCity', payload);
}

export const updateCityApi = (payload) => {
    return putApiWithToken('/admin/updateCity', payload);
}

export const deleteCityApi = (payload) => {
    return deleteApi('/admin/deleteCity', payload);
}

export const citySuggestionsApi = (city = "", countryCode="") => {
    return getApiWithToken(`/admin/citySuggestions?city=${city}&countryCode=${countryCode}`);
}


export const addOrUpdateServieAreaCitiesApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateServieAreaCities`,payload);
}
export const addOrUpdateSosApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateSos`,payload);
}

export const deleteServiceAreaCityApi = (payload) => {
    return deleteApi(`/admin/deleteServiceAreaCity`, payload);
}
export const removeSosApi = (payload) => {
    return deleteApi(`/admin/removeSos`, payload);
}

export const enableOrDisableServiceAreaCountryApi = (payload) => {
    return putApiWithToken(`/admin/enableOrDisableServiceAreaCountry`, payload);
}

export const surgePeriodListApi = (categoryId="", type="") => {
    return getApiWithToken(`/admin/surgePeriodList?categoryId=${categoryId}&type=${type}`);
}

export const createOrUpdateSurgePeriodApi = (payload) => {
    return postApiWithToken(`/admin/createOrUpdateSurgePeriod`,payload);
}

export const updateSurgePeriodStatus = (payload) => {
    return putApiWithToken(`/admin/updateSurgePeriodStatus`, payload)
}

export const enableOrDisableSurgePeriodApi = (payload) => {
    return putApiWithToken(`/admin/enableOrDisableSurcharePeriod`, payload)
}

export const getUserRidesListApi = (page = "", limit= "", filter="all", userId="") => {
    return getApiWithToken(`/admin/getUserRidesList?page=${page}&limit=${limit}&filter=${filter}&userId=${userId}`);
}

export const cityListApi = (city = "") => {
    return getApiWithToken(`/admin/cityList?city=${city}`);
}

export const countryListApi = (search = "") => {
    return getApiWithToken(`/admin/countryList?search=${search}`);
}

export const serviceAreaCitiesApi = (countryId = "", search = "") => {
    return getApiWithToken(`/admin/serviceAreaCities?countryId=${countryId}&search=${search}`);
}
export const serviceAreaCountriesApi  = (search = "") => {
    return getApiWithToken(`/admin/serviceAreaCountries?search=${search}`);
}
export const countryWithSosApi  = (search = "") => {
    return getApiWithToken(`/admin/countryWithSos?search=${search}`);
}
export const getSosListApi = (countryId = "", search = "") => {
    return getApiWithToken(`/admin/getSosList?countryId=${countryId}&search=${search}`);
}

export const enableOrDisableServiceAreaCitiesApi = (payload) => {
    return putApiWithToken(`/admin/enableOrDisableServiceAreaCities`, payload)
}

export const cityByCountryApi = (search = "",countryId="") => {
    return getApiWithToken(`/admin/cityByCountry?search=${search}${countryId ? `&countryId=${countryId}`: ''}`);
}

export const bonusListApi = (countryId = "", cityId = "",bonusFor="") => {
    return getApiWithToken(`/admin/bonusList?countryId=${countryId}&cityId=${cityId}&bonusFor=${bonusFor}`);
}

export const bonusCityAndCountryListApi = (countryId = "", cityId = "",bonusFor="") => {
    return getApiWithToken(`/admin/bonusCityAndCountry?countryId=${countryId}&cityId=${cityId}&bonusFor=${bonusFor}`);
}

export const addOrUpdateBonus = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateBonus`,payload);
}

export const updateBonusStatus = (payload) => {
    return postApiWithToken(`/admin/updateBonusStatus`,payload);
}


export const updateDiscountStatusApi = (payload) => {
    return postApiWithToken(`/admin/updateDiscountStatus`,payload);
}

export const updateRestaurantFeeOnOffApi = (payload) => {
    return postApiWithToken(`/admin/updateRestaurantFeeOnOff`,payload);
}

export const SubscriptionDriverApi = (categoryId = "", type = "") => {
    return getApiWithToken(`/admin/subscriptionList?categoryId=${categoryId}&type=${type}`);
}

export const addOrUpdateSubscriptionDriverApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateSubscription`,payload);
}

export const updateSubscriptionDriverStatus = (payload) => {
    return postApiWithToken(`/admin/updateSubscriptionStatus`,payload);
}

export const updateSubscriptionFeeAndCommissionFeeApi = (payload) => {
    return putApiWithToken(`/admin/updateSubscriptionAndCommissionFee`, payload)
}

export const getDefaultCategoryListApi = (bookingType = "", rentalVehicleType = "", countryId = "", cityId = "") => {
    return getApiWithToken(`/admin/defaultCategoryList?bookingType=${bookingType}&rentalVehicleType=${rentalVehicleType}&countryId=${countryId}&cityId=${cityId}`)
}

export const defaultCategoryListOptionsApi = (bookingType = "yiinoRide") => {
    return getApiWithToken(`/admin/defaultCategoryListOptions?bookingType=${bookingType}`)
}

export const addOrUpdateDefaultCategoryApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateDefaultCategory`, payload)
}

export const updateDefaultCategoryApi = (payload) => {
    return putApiWithToken(`/admin/updateDefaultCategoryStatus`, payload)
}

export const defaultCategoryByIdApi = (id='') => {
    return getApiWithToken(`/admin/defaultCategoryById?id=${id}`)
}

export const getCategoryByIdApi = (id='') => {
    return getApiWithToken(`/admin/getCategoryById?id=${id}`)
}

export const partnerEarningWithdrawRequestApi = (id = "", limit = "", page = "", country = "", city = "") => {
    return getApiWithToken(`/admin/partnerEarningWithdrawRequest?id=${id}&page=${page}&limit=${limit}&country=${country}&city=${city}`)
}

export const changePartnerEarningWithdrawRequestStatusApi = (payload) => {
    return putApiWithToken(`/admin/changePartnerEarningWithdrawRequestStatus`, payload)
}
// ------------ global settings --------------------

export const getAppVersionDataApi = () => {
    return getApiWithToken(`/admin/getAppVersionData`)
}

export const getAllAppBannerImagesApi = (type = "") => {
    return getApiWithToken(`/admin/getAllAppBannerImages?type=${type}`)
}

export const updateAppBannerSerialNoApi = (payload) => {
    return putApiWithToken(`/admin/updateAppBannerSerialNo`, payload)
}

export const updateAppVersionDataApi = (payload) => {
    return putApiWithToken(`/admin/updateAppVersionData`, payload)
}

export const addOrUpdateAppBannerImagesApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateAppBannerImages`, payload)
}

export const deleteAppBannerImageApi = (payload) => {
    return deleteApi(`/admin/deleteAppBannerImage`, payload)
}


// ------------ Administrator --------------------

export const getAllAdminListApi = (page="", limit="", search= "" ) => {
    return getApiWithToken(`/admin/administrators?page=${page}&limit=${limit}&search=${search}`)
}

export const addOrUpdateAdministratorsApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateAdministrators`, payload)
}

export const enableOrdisableAdministratorApi = (payload) => {
    return putApiWithToken(`/admin/enableOrdisableAdministrator`, payload)
}

// ----------  Package ----------------------------------------
export const addOrUpdatePackageDefaultCategoryApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateDefaultPackageCategory`, payload)
}

// ----------  Rental ----------------------------------------
export const addOrUpdateRentalDefaultCategoryApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateDefaultRentalsCategory`, payload)
}


// ----------  Sales Agent ----------------------------------------
export const salesAgentByIdApi = ({ id, page = 1, limit = 10 }) => {
    return getApiWithToken(
        `/admin/salesAgentById?id=${id}&page=${page}&limit=${limit}`
    );
};



export const updateSalesAgentRatesApi = (payload) => {
    return putApiWithToken(`/admin/updateSalesAgentRates`, payload)
}

export const approveOrRejectSalesAgentDocumentsApi = async (data) => {
    return putApiWithToken(`/admin/approveOrRejectSalesAgentDocumentsApi`, data)
}

export const addOrUpdateReferralDetailsApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateReferralDetails`, payload)
}

export const getReferralDetailsApi = (countryId="", cityId="") => {
    return getApiWithToken(`/admin/getReferralDetails?countryId=${countryId}&cityId=${cityId}`)
}

export const getReferralDataApi = (country="", city="") => {
    return getApiWithToken(`/admin/getReferralData?country=${country}&city=${city}`)
}

export const enableOrDisableBonusApi = (payload) => {
    return putApiWithToken(`/admin/enableOrDisableBonus`, payload)
}

export const updateDriverMinWalletBalanceApi = (payload) => {
    return putApiWithToken(`/admin/updateDriverMinWalletBalance`, payload)    
}
export const updateRentalChargesApi = (payload) => {
    return putApiWithToken(`/admin/updateRentalCharges`, payload)    
}
export const updateSalesChargesApi = (payload) => {
    return putApiWithToken(`/admin/updateSalesCharges`, payload)    
}
export const getUserDetailsByIdApi = (userId = "") => {
    return getApiWithToken(`/admin/getUserDetailsById?userId=${userId}`)    
}

export const addOrUpdateDiscountDetailsApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateDiscountDetails`, payload)
}
export const getDiscountListApi = (countryId = "", cityId = "") => {
    return getApiWithToken(`/admin/getDiscountList?countryId=${countryId}&cityId=${cityId}`)
}

export const deleteDiscountApi = (payload) => {
    return deleteApi(`/admin/deleteDiscountById`, payload);
}


export const getNotificationListApi = (countryId = "", cityId = "") => {
    return getApiWithToken(`/admin/getNotificationList?countryId=${countryId}&cityId=${cityId}`)
}

export const addOrUpdateNotificationApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateNotification`, payload)
}
export const sendAdminNotificationApi = (payload) => {
    return postApiWithToken(`/admin/sendAdminNotification`, payload)
}

export const addOrUpdateSupportQuestionApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateSupportQuestion`, payload)
}

export const getSupportQuestionListApi = (type="") => {
    return getApiWithToken(`/admin/getSupportQuestionList?type=${type}`)
}

export const termsAndConditionsListApi = () => {
    return getApiWithoutToken(`/getTermAndConditionsTypes`);
}

export const deleteSupportQuestionApi = (payload) => {
    return deleteApi(`/admin/deleteSupportQuestion`, payload);
}

export const getTermsAndConditonsApi = (type = "") => {
    return getApiWithToken(`/getTermAndConditions?type=${type}`)
}

export const addOrUpdateTermAndConditionsApi = (payload) => {
    return postApiWithToken(`/addOrUpdateTermAndConditions`, payload)
}
export const addOrUpdatePackageDetailsApi = (payload) => {
    return postApiWithToken(`/admin/addorupdatepackagedetails`, payload);
};
export const getPackageDetailsApi = () => {
    return getApiWithToken(`/admin/getPackageDetails`);
};

export const addBlogApi = (payload) => {
    return postApiWithToken(`/blog/add-blog`, payload)
}
export const updateSeatApi = (payload) => {
  return putApiWithToken("/admin/updateSeat", payload);
};
export const updateSeatHireApi = (payload) => {
  return putApiWithToken("/admin/updatehireSeat", payload);
};
export const updateBlogApi = (payload) => {
    return putApiWithToken(`/blog/update-blog`, payload)
}
export const deleteBlogApi = (payload) => {
    return putApiWithToken(`/blog/delete-blog`, payload);

}

export const getBlogApi = (search="", limit ="", page="") => {
    return getApiWithToken(`/blog/get-blog?search=${search}&limit=${limit}&page=${page}&appType=admin`);
}
export const getLearningsApi = (lang) => {
    return getApiWithToken(`/admin/getLearnings?lang=${lang}`);
}
export const addOrUpdateLearningApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateLearning`, payload);
}
export const getJobListApi = (page = "", limit = "", countryId="", cityId="") => {
    return getApiWithToken(`/admin/getJobList?limit=${limit}&page=${page}&countryId=${countryId}&cityId=${cityId}`);
}
export const getJobCategoryApi = ( limit ="", page="") => {
    return getApiWithToken(`/admin/getJobCategory?limit=${limit}&page=${page}`);
}

export const addOrUpdateJobApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateJob`, payload)
}
export const addOrUpdateJobCategoryApi = (payload) => {
    return postApiWithToken(`/admin/addOrUpdateJobCategory`, payload)
}

export const adminDashboardDetailsApi = async (countryName="",cityName="") => {
    return getApiWithToken(`/admin/adminDashboardDetails?countryName=${countryName}&cityName=${cityName}`)
}

export const getAllRestaurantApi = (id="",limit = "", page = "", search = "") => {
    return getApiWithToken(`/admin/getAllMenuByRestaurantId?id=${id}&search=${search}&page=${page}&limit=${limit}`)
}

export const getPartnerAllReviewApi = (id="",limit = "", page = "", search = "") => {
    return getApiWithToken(`/admin/getAllReviewByPartnerId?id=${id}&search=${search}&page=${page}&limit=${limit}`)
}

export const savePartnerBankDetailsApi = (payload) => {
    return postApiWithToken(`/admin/savePartnerBankDetails`,payload)
}

export const getVehicleCategoryListApi = (partnerUserId="", category="", make="", model="") => {
    return getApiWithToken(`/admin/getVehicleCategoryList?partnerUserId=${partnerUserId}&category=${category}&make=${make}&model=${model}`)
}

export const createOrUpdateVehicleDetailsApi = (payload) => {
    return postApiWithToken(`/admin/createOrUpdateVehicleDetails`,payload)
}

export const createOrUpdateRentalVehicleDetailsApi = (payload) => {
    return postApiWithToken(`/admin/createOrUpdateRentalVehicleDetails`,payload)
}

export const updatePartnerProfileApi = (payload) => {
    return postApiWithToken(`/admin/updatePartnerProfile`,payload)
}

export const getAddressSuggestionsApi = ( address="", countryCode="") => {
    return getApiWithToken(`/admin/getAddressSuggestions?address=${address}&countryCode=${countryCode}`)
}

export const getAddressDetailsByPlaceIdApi = ( placeId="", ) => {
    return getApiWithToken(`/admin/getAddressDetailsByPlaceId?placeId=${placeId}`)
}
export const getAboutUsApi = ( placeId="", ) => {
    return getApiWithToken(`/admin/getAboutUs`)
}

export const updateDriverDocsApi = (payload) => {
    return putApiWithToken(`/admin/updateDriverDocs`,payload)
}
export const addOrUpdateAboutUsApi = (payload) => {
    return putApiWithToken(`/admin/addOrUpdateAboutUs`,payload)
}

export const updateRestaurantDetailsApi = (payload) =>{
    return putApiWithToken(`/admin/updateRestaurantDetails`,payload)
}


export const updateRestaurantDocApi = (payload) =>{
    return putApiWithToken(`/admin/updateRestaurantDoc`,payload)
}

export const updateMenuItemDetailsApi = (payload) =>{
    return putApiWithToken(`/admin/UpdateMenuItemDetails`,payload)
}

export const updateSalesAgentDocsApi = (payload) =>{
    return putApiWithToken(`/admin/updateSalesAgentDocs`,payload)
}

// bus operator start
export const getBusOperatorDetailsApi = (id) => {
    return getApiWithToken(`/admin/getBusOperatorDetailsById?id=${id}`)
}

export const busOperatorRateApi = (payload) => {
    return putApiWithToken(`/admin/updateBusOperatorRate`, payload)    
}
export const updateBusOperatorDetailsApi = (payload) => {
    return putApiWithToken(`/admin/updateBusOperatorDetails`, payload)    
}

export const updateBusOperatorCommissionApi = (payload) => {
    return putApiWithToken(`/admin/updateBusOperatorCommission`, payload)    
}

// bus operator end

export const getAllJobApplicationApi = (page="", limit="", search= "" ) => {
    return getApiWithToken(`/admin/getAllJobApplication?page=${page}&limit=${limit}&search=${search}`)
}

export const updateJobApplicationApi = (payload) => {
    return putApiWithToken(`/admin/updateJobApplication`, payload)    
}

export const getContactRequestsApi = (page="", limit="", search= "" ) => {
    return getApiWithToken(`/admin/getContactRequests?page=${page}&limit=${limit}&search=${search}`)
}

export const removeJobCategoryApi = (payload) => {
    return deleteApi(`/admin/removeJobCategory`, payload);
}

export const getFleetOwnerRideVehiclesApi = (userId,page="", limit="",search="",isTable="") => {
  return getApiWithToken(`/admin/getFleetOwnerVehicles?userId=${userId}&page=${page}&limit=${limit}&search=${search}&isTable=${isTable}`);
}

export const getFleetOwnerDriversApi = (userId,page="", limit="",search="",isTable="") => {
  return getApiWithToken(`/admin/getFleetOwnerDrivers?fleetOwnerId=${userId}&page=${page}&limit=${limit}&search=${search}&isTable=${isTable}`);
}

export const adminChangeUserAccountStatusApi = async (data) => {
    const res = await postApiWithToken(`/admin/changeUserAccountStatus`, data)
    return res;
}
export const sendOtpApi = (payload)=>{
  return postApiWithoutToken(`/admin/sendOtpToEmail`,payload)
}

export const verifyOtpApi = (payload)=>{
  return postApiWithoutToken(`/admin/verifyEmailByOtp`,payload)
}

export const sendCredentialsApi = (payload) => {
  return postApiWithoutToken(`/admin/send-credentials`, payload);
};

// /addOrUpdateOfficeAddress
export const addOrUpdateOfficeAddressApi = (payload) => {
  return postApiWithToken(`/admin/addOrUpdateOfficeAddress`, payload);
};
export const getAllOfficeAddressesApi = () => {
  return getApiWithToken("/admin/getAllOfficeAddresses");
};

//apiendpoint for walletHistoriesApi
// export const walletHistoriesApi = (id) => {
//   return getApiWithToken(`/admin/getWalletHistories?id=${id}`);
// };
export const getBankDetailsApi = () => {
  return getApiWithToken("/admin/getAllBankDetails");
};



export const getAllRaferralsApi = (id="",page="", limit="", search= "", sort="", sortOrder="") => {
    return getApiWithToken(`/admin/getAllRaferrals?page=${page}&limit=${limit}&search=${search}&sort=${sort}&sortOrder=${sortOrder}&id=${id}`)
}


export const updatefleetOwnerDriverApi = (payload)=>{
  return putApiWithToken(`/admin/updateFleetOwnerDrivers`,payload)
}

export const updateFleetOwnerVehicleApi = (payload)=>{
  return putApiWithToken(`/admin/updateFleetOwnerVehicle`,payload)
}

export const getBusOperatorDriversApi = (userId,page="", limit="",search="",isTable="") => {
  return getApiWithToken(`/admin/getBusOperatorDrivers?partnerUserId=${userId}&page=${page}&limit=${limit}&search=${search}&isTable=${isTable}`);
}

export const updateBusOperaotrStaffApi = (payload)=>{
  return putApiWithToken(`/admin/updateBusOperaotrStaff`,payload)
}

export const addBusOperaotrStaffApi = (payload) => {
  return postApiWithToken(`/admin/addBusOperaotrStaff`, payload);
};

export const getBusOperatorVehiclesApi = (userId,page="", limit="",search="",isTable="") => {
  return getApiWithToken(`/admin/getBusOperatorVehicles?partnerUserId=${userId}&page=${page}&limit=${limit}&search=${search}&isTable=${isTable}`);
}

export const updateBusOperaotrVehiclesApi = (payload)=>{
  return putApiWithToken(`/admin/updateBusOperaotrVehicles`,payload)
}
//api endpoin for getCommissionForFleetByFleetId
export const getCommissionForFleetByFleetId = (fleetId) => {
  return getApiWithToken(`/admin/getCommissionForFleetByFleetId?id=${fleetId}`);
};

//api end point for /switchRole
export const switchRoleApi = (payload) => {
  return postApiWithToken(`/admin/switchRole`, payload);
}

export const notifyIncompleteProfilesApi = () => {
  return postApiWithToken(`/admin/notifyIncompleteProfiles`);
}
 
 //api endpoint for fleetcommissions
export const getFleetCommissionsApi = (userId) => {
  return getApiWithToken(`/admin/fleetcommissions?userId=${userId}`);
}
 //apiendpoint for updateFleetCommissionsApi
export const updateFleetCommissionsApi = (payload) => {
  return postApiWithToken(`/admin/updateFleetCommission`, payload);
}

export const getSalesAgentRatesApi = (partnerUserId) => {
  return getApiWithToken(`/admin/getSalesAgentRates?id=${partnerUserId}`);
};

export const addSalesAgentRatesApi = (payload) => {
  return postApiWithToken(`/admin/addSalesAgentRates/${payload.partnerUserId}`,payload);
};


export const updateSalesAgentRateApi = (payload) => {
  return postApiWithToken(`/admin/updateSalesAgentRates`,payload);
};

export const updateBonusWithdrawalLimitApi = (payload) => {
  return postApiWithToken(`/admin/updateBonusWithdrawalLimit`,payload);
}

export const partnerEarningWithdrawRequestListDownload = (country = "", city = "") => {
  return getApiWithToken(`/admin/partnerEarningWithdrawRequestListDownload?country=${country}&city=${city}`);
}
 //api end point for getPackageTypes
export const getPackageTypesApi = () => {
  return getApiWithToken(`/admin/getPackageTypes`);
}
 //apiendpoint for addOrUpdatePackageType
export const addPackageTypeApi = (payload) => {
  return postApiWithToken(`/admin/addPackageType`, payload);
}
                 
//api end point for deletePackageType
export const deletePackageTypeApi = (payload) => {
  return postApiWithToken(`/admin/deletePackageType`, payload);
}

export const deleteLearningApi =(id)=>{
    return putApiWithToken(`/admin/deleteLearning?id=${id}`)
}

export const addNewUserApi = (payload) => {
  return postApiWithToken(`/admin/addNewUser`, payload);
}

export const otpByPassApi = (payload)=>{
  return putApiWithToken(`/admin/otpBypass`,payload)
}

export const getWeeklyWithdrawalsDatesApi = ()=>{
  return getApiWithToken(`/admin/getWeeklyWithdrawalsDates`)
}

export const getWeeklyWidhdrawalRequestsApi = (from,to,page = 1,limit = 10) => {
  return getApiWithToken(`/admin/getWeeklyWidhdrawalRequests?from=${from}&to=${to}&page=${page}&limit=${limit}`);
};

export const downloadWeeklyWithdrawalsApi = (from, to) => {
  return getApiWithToken(`/admin/downloadWeeklyWithdrawalsJSON?from=${from}&to=${to}`);
};

export const markWeeklyWithdrawalPaidApi = (payload) => {
  return putApiWithToken(`/admin/markWeeklyWithdrawalPaid`, payload);
}

export const getAllRewardWithdrawRequestsApi = (page = 1, limit = 10) => {
  return getApiWithToken(`/admin/getAllRewardWithdrawRequests?page=${page}&limit=${limit}`);
}

export const markPaidrewardWithdrawalApi = (payload) => {
  return putApiWithToken(`/admin/changePartnerRewardWithdrawRequestStatus`, payload);
}